import { css } from '@repo/pandacss/styled-system/css';
import type { Category } from './Categories';
import { ChartLegendItem } from './ChartLegendItem';

interface ChartLegendProps {
  data: Category[];
}

export function ChartLegend({ data }: ChartLegendProps) {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        flexGrow: '[60]',
        flexShrink: '1',
        flexBasis: '[0%]',
        alignSelf: 'start',
        width: 'full',
      })}
    >
      {data.map((item, index) => (
        <ChartLegendItem key={item.label} item={item} index={index} />
      ))}
    </div>
  );
}
